import { render, staticRenderFns } from "./DiscoverFilter.vue?vue&type=template&id=0e535f50&"
import script from "./DiscoverFilter.vue?vue&type=script&lang=js&"
export * from "./DiscoverFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports